// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/modules/Courier/pages/Route/RouteInfo/RouteInfo.module.css */
.RouteInfo_container__XSQ8W {
  background: #fff;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  margin-bottom: 16px;
}

.RouteInfo_title__PNvR2 {
  font-size: 1.25rem;
  margin-bottom: 12px;
  color: rgb(red, green, blue);
}
.RouteInfo_clickableHeader__\\+2Mff {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;          /* show pointer on hover */
  -webkit-user-select: none;
          user-select: none;        /* prevent text highlight on tap */
  background: var(--bg-light);
  border-radius: var(--radius);
  /* optional shadow or border to highlight the header area */
  transition: background .2s;
}
.RouteInfo_clickableHeader__\\+2Mff:hover {
  background: var(--bg-hover);
}

/* Move chevron styles into your module */
.RouteInfo_chevronDown__uZhFQ {
right: 0%;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid var(--text-color);
}
.RouteInfo_chevronUp__JfvHy {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid var(--text-color);
}

.RouteInfo_row__E\\+upB {
  margin: 4px 0;
}

.RouteInfo_stats__gmPkg {
  display: flex;
  gap: 12px;
  margin-top: 8px;
  font-size: 0.95rem;
}

.RouteInfo_progressWrapper__N9A41 {
  margin-top: 12px;
}

.RouteInfo_progressBar__pgE-a {
  display: flex;
  height: 10px;
  border-radius: 4px;
  overflow: hidden;
  background-color: #e0e0e0;
}

.RouteInfo_filledDelivered__cCt5Q {
  background-color: #28a745;
}

.RouteInfo_filledInProgress__b29WM {
    background-color: #ffc107;
    background-color: rgb(0, 123, 255);
}

.RouteInfo_filledUndelivered__JCjJ6 {
  background-color: #dc3545;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Courier/Route/RouteInfo/RouteInfo.module.css"],"names":[],"mappings":"AAAA,mEAAmE;AACnE;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe,WAAW,0BAA0B;EACpD,yBAAiB;UAAjB,iBAAiB,SAAS,kCAAkC;EAC5D,2BAA2B;EAC3B,4BAA4B;EAC5B,2DAA2D;EAC3D,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;;AAEA,yCAAyC;AACzC;AACA,SAAS;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,uCAAuC;AACzC;AACA;EACE,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* src/modules/Courier/pages/Route/RouteInfo/RouteInfo.module.css */\r\n.container {\r\n  background: #fff;\r\n  padding: 16px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.title {\r\n  font-size: 1.25rem;\r\n  margin-bottom: 12px;\r\n  color: rgb(red, green, blue);\r\n}\r\n.clickableHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 12px 16px;\r\n  cursor: pointer;          /* show pointer on hover */\r\n  user-select: none;        /* prevent text highlight on tap */\r\n  background: var(--bg-light);\r\n  border-radius: var(--radius);\r\n  /* optional shadow or border to highlight the header area */\r\n  transition: background .2s;\r\n}\r\n.clickableHeader:hover {\r\n  background: var(--bg-hover);\r\n}\r\n\r\n/* Move chevron styles into your module */\r\n.chevronDown {\r\nright: 0%;\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 6px solid transparent;\r\n  border-right: 6px solid transparent;\r\n  border-top: 6px solid var(--text-color);\r\n}\r\n.chevronUp {\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 6px solid transparent;\r\n  border-right: 6px solid transparent;\r\n  border-bottom: 6px solid var(--text-color);\r\n}\r\n\r\n.row {\r\n  margin: 4px 0;\r\n}\r\n\r\n.stats {\r\n  display: flex;\r\n  gap: 12px;\r\n  margin-top: 8px;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.progressWrapper {\r\n  margin-top: 12px;\r\n}\r\n\r\n.progressBar {\r\n  display: flex;\r\n  height: 10px;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n  background-color: #e0e0e0;\r\n}\r\n\r\n.filledDelivered {\r\n  background-color: #28a745;\r\n}\r\n\r\n.filledInProgress {\r\n    background-color: #ffc107;\r\n    background-color: rgb(0, 123, 255);\r\n}\r\n\r\n.filledUndelivered {\r\n  background-color: #dc3545;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RouteInfo_container__XSQ8W`,
	"title": `RouteInfo_title__PNvR2`,
	"clickableHeader": `RouteInfo_clickableHeader__+2Mff`,
	"chevronDown": `RouteInfo_chevronDown__uZhFQ`,
	"chevronUp": `RouteInfo_chevronUp__JfvHy`,
	"row": `RouteInfo_row__E+upB`,
	"stats": `RouteInfo_stats__gmPkg`,
	"progressWrapper": `RouteInfo_progressWrapper__N9A41`,
	"progressBar": `RouteInfo_progressBar__pgE-a`,
	"filledDelivered": `RouteInfo_filledDelivered__cCt5Q`,
	"filledInProgress": `RouteInfo_filledInProgress__b29WM`,
	"filledUndelivered": `RouteInfo_filledUndelivered__JCjJ6`
};
export default ___CSS_LOADER_EXPORT___;
